/* eslint-disable react/no-array-index-key */
import React, {
  lazy,
  Suspense,
  Fragment
} from 'react';
import {
  Switch,
  Redirect,
  Route
} from 'react-router-dom';
import DashboardLayout from 'src/layouts/DashboardLayout';
// import DocsLayout from 'src/layouts/DocsLayout';
import MainLayout from 'src/layouts/MainLayout';
import HomeView from 'src/views/pages/HomeView';
import LoadingScreen from 'src/components/LoadingScreen';
import AuthGuard from 'src/components/AuthGuard';
import GuestGuard from 'src/components/GuestGuard';
import FunctionGuard from 'src/components/FunctionGuard';

const routesConfig = [
  {
    exact: true,
    path: '/',
    component: () => <Redirect to="/login" />
  },
  {
    exact: true,
    path: '/404',
    component: lazy(() => import('src/views/pages/Error404View'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/login',
    component: lazy(() => import('src/views/auth/LoginView'))
  },
  {
    exact: true,
    path: '/login-unprotected',
    component: lazy(() => import('src/views/auth/LoginView'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/register',
    component: lazy(() => import('src/views/auth/RegisterView'))
  },
  // {
  //   exact: true,
  //   guard: GuestGuard,
  //   path: '/recuperar-senha',
  //   component: lazy(() => import('src/views/auth/PasswordView'))
  // },
  {
    exact: true,
    path: '/register-unprotected',
    component: lazy(() => import('src/views/auth/RegisterView'))
  },
  {
    path: '/app',
    guard: AuthGuard,
    layout: DashboardLayout,
    routes: [
      {
        exact: true,
        path: '/app',
        component: () => <Redirect to="/app/account" />
      },
      {
        exact: true,
        path: '/app/account',
        component: lazy(() => import('src/views/pages/AccountView'))
      },
      {
        exact: true,
        path: '/app/reports/dashboard',
        guard: FunctionGuard,
        functionOptions: ['admin', 'owner'],
        component: lazy(() => import('src/views/reports/DashboardView'))
      },
      {
        exact: true,
        path: '/app/reports/dashboard-alternative',
        guard: FunctionGuard,
        functionOptions: ['admin', 'owner'],
        component: lazy(() => import('src/views/reports/DashboardAlternativeView'))
      },
      {
        exact: true,
        path: '/app/management/accounts',
        guard: FunctionGuard,
        functionOptions: ['admin', 'owner'],
        component: lazy(() => import('src/views/management/AccountListView'))
      },
      {
        exact: true,
        path: '/app/management/accounts/create',
        guard: FunctionGuard,
        functionOptions: ['admin', 'owner'],
        component: lazy(() => import('src/views/management/AccountCreateView'))
      },
      {
        exact: true,
        path: '/app/management/accounts/:accountId/edit',
        guard: FunctionGuard,
        functionOptions: ['admin', 'owner'],
        component: lazy(() => import('src/views/management/AccountEditView'))
      },
      {
        exact: true,
        path: '/app/management/campaign/:campaignId/edit',
        guard: FunctionGuard,
        functionOptions: ['admin', 'owner'],
        component: lazy(() => import('src/views/management/CampaignEditView'))
      },
      {
        exact: true,
        path: '/app/management/customers',
        guard: FunctionGuard,
        functionOptions: ['seller', 'admin', 'owner'],
        component: lazy(() => import('src/views/management/CustomerListView'))
      },
      {
        exact: true,
        path: '/app/management/customers/:customerId',
        guard: FunctionGuard,
        functionOptions: ['seller', 'admin', 'owner'],
        component: lazy(() => import('src/views/management/CustomerDetailsView'))
      },
      {
        exact: true,
        path: '/app/management/customers/:customerId/edit',
        guard: FunctionGuard,
        functionOptions: ['admin', 'owner'],
        component: lazy(() => import('src/views/management/CustomerEditView'))
      },
      {
        exact: true,
        path: '/app/management/select-products/create',
        guard: FunctionGuard,
        functionOptions: ['seller', 'admin', 'owner'],
        component: lazy(() => import('src/views/management/SelectProductsCreateView'))
      },
      {
        exact: true,
        path: '/app/management/campaigns/list',
        guard: FunctionGuard,
        functionOptions: ['admin', 'owner'],
        component: lazy(() => import('src/views/management/CampaignListView'))
      },
      {
        exact: true,
        path: '/app/management/campaigns/create',
        guard: FunctionGuard,
        functionOptions: ['admin', 'owner'],
        component: lazy(() => import('src/views/management/CampaignCreateView'))
      },
      {
        exact: true,
        path: '/app/management/select-products/list/',
        guard: FunctionGuard,
        functionOptions: ['seller', 'admin', 'owner'],
        component: lazy(() => import('src/views/management/SelectProductsListView'))
      },
      {
        exact: true,
        path: '/app/management/select-products/detail/:orderId',
        guard: FunctionGuard,
        functionOptions: ['seller', 'admin', 'owner'],
        component: lazy(() => import('src/views/management/SelectProductsDetailView'))
      },
      {
        exact: true,
        path: '/app/management/campaigns/detail/:campaignId',
        guard: FunctionGuard,
        functionOptions: ['admin', 'owner'],
        component: lazy(() => import('src/views/management/CampaignDetailView'))
      },
      {
        exact: true,
        path: '/app/management/products',
        guard: FunctionGuard,
        functionOptions: ['admin', 'owner'],
        component: lazy(() => import('src/views/management/ProductListView'))
      },
      {
        exact: true,
        path: '/app/management/products/create',
        guard: FunctionGuard,
        functionOptions: ['admin', 'owner'],
        component: lazy(() => import('src/views/management/ProductCreateView'))
      },
      {
        exact: true,
        path: '/app/management/products/:productId',
        guard: FunctionGuard,
        functionOptions: ['admin', 'owner'],
        component: lazy(() => import('src/views/management/ProductCreateView'))
      },
      {
        exact: true,
        path: '/app/management/orders',
        guard: FunctionGuard,
        functionOptions: ['separator', 'admin', 'owner', 'attendant', 'seller'],
        component: lazy(() => import('src/views/management/OrderListView'))
      },
      {
        exact: true,
        path: '/app/management/abandoned-carts',
        guard: FunctionGuard,
        functionOptions: ['separator', 'admin', 'owner', 'attendant', 'seller'],
        component: lazy(() => import('src/views/management/AbandonedCartsView'))
      },
      {
        exact: true,
        path: '/app/management/abandoned-carts/:abandonedCartId',
        guard: FunctionGuard,
        functionOptions: ['separator', 'admin', 'owner', 'attendant', 'seller'],
        component: lazy(() => import('src/views/management/OrderDetailsView'))
      },
      {
        exact: true,
        path: '/app/management/abandoned-carts/:abandonedCartId/add-product',
        guard: FunctionGuard,
        functionOptions: ['separator', 'admin', 'owner', 'attendant', 'seller'],
        component: lazy(() => import('src/views/management/OrderSelectProductView'))
      },
      {
        exact: true,
        path: '/app/management/orders-confirmation',
        guard: FunctionGuard,
        functionOptions: ['separator', 'admin', 'owner'],
        component: lazy(() => import('src/views/management/OrderConfirmation'))
      },
      {
        exact: true,
        path: '/app/management/categories',
        guard: FunctionGuard,
        functionOptions: ['admin', 'owner'],
        component: lazy(() => import('src/views/management/ProductCategories'))
      },
      {
        exact: true,
        path: '/app/management/categories/create',
        guard: FunctionGuard,
        functionOptions: ['admin', 'owner'],
        component: lazy(() => import('src/views/management/ProductCategoriesCreate'))
      },
      {
        exact: true,
        path: '/app/management/categories/:categoryId/edit',
        guard: FunctionGuard,
        functionOptions: ['admin', 'owner'],
        component: lazy(() => import('src/views/management/ProductCategoriesCreate'))
      },
      {
        exact: true,
        path: '/app/management/orders/:orderId',
        guard: FunctionGuard,
        functionOptions: ['separator', 'admin', 'owner', 'attendant', 'seller'],
        component: lazy(() => import('src/views/management/OrderDetailsView'))
      },
      {
        exact: true,
        path: '/app/management',
        component: () => <Redirect to="/app/management/customers" />
      },
      {
        exact: true,
        path: '/app/settings/notifications',
        functionOptions: ['admin', 'owner'],
        component: lazy(() => import('src/views/settings/notifications/NotificationsSettingsView'))
      },
      {
        exact: true,
        path: '/app/settings/exchanges',
        functionOptions: ['admin', 'owner'],
        component: lazy(() => import('src/views/settings/exchanges/ExchangeSettingsView'))
      },
      {
        component: () => <Redirect to="/404" />
      }
    ]
  },
  {
    path: '*',
    layout: MainLayout,
    routes: [
      {
        exact: true,
        path: '/home',
        component: HomeView
      },
      {
        component: () => <Redirect to="/404" />
      }
    ]
  }
];

const renderRoutes = (routes) => (routes ? (
  <Suspense fallback={<LoadingScreen />}>
    <Switch>
      {routes.map((route, i) => {
        const Guard = route.guard || Fragment;
        const functionOptions = route.functionOptions || [];
        const Layout = route.layout || Fragment;
        const Component = route.component;

        return (
          <Route
            key={i}
            path={route.path}
            exact={route.exact}
            render={(props) => (
              <Guard options={functionOptions}>
                <Layout>
                  {route.routes
                    ? renderRoutes(route.routes)
                    : <Component {...props} />}
                </Layout>
              </Guard>
            )}
          />
        );
      })}
    </Switch>
  </Suspense>
) : null);

function Routes() {
  return renderRoutes(routesConfig);
}

export default Routes;
